import { buildLink } from '../../types/builders';
import adapter from './adapter-restaurants-order-page';
var IDs = adapter.IDs;
export var RESTAURANTS_ORDER_PAGE = {
    tags: [buildLink('canonical', "{{" + IDs.ORDER_PAGE_URL + "}}")],
};
